export default "__VITE_ASSET__DFL1scOk__"